import React from 'react';
import { Col, Radio, RadioGroup, Row, themes } from '@digitools/honest-react';
import useCliDataContext from '../../../hooks/useCliDataContext';
import AboutYourAbsenceText from 'src/packages/cli/constants/AboutYourAbsenceText';
import useTranslate from 'src/hooks/useTranslate';
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
import useExperience from 'src/hooks/useExperience';
import { Experience } from 'src/types/Experience';
//TODO: May need to hide & default for certain formState!
const HospitalizationIndicator = (props) => {
    const { absenceData } = useCliDataContext();
    const { experience } = useExperience();
    const { t } = useTranslate();
    const { formLabels } = AboutYourAbsenceText;
    const hospitalizationIndicatorLabel = CustomEmployeeText(experience === Experience.EMPLOYEE
        ? t(formLabels.hospitalizationIndicatorEE)
        : `${t(formLabels.hospitalizationIndicatorER)}`);
    const hospitalizationIndicatorShortLabel = experience === Experience.EMPLOYEE
        ? t(formLabels.hospitalizationShortLabel)
        : formLabels.hospitalizationShortLabel.english;
    return (<>
      <Row data-testid='hospitalizationIndicator' className='mb-3'>
        <Col xs={12}>
          <RadioGroup label={hospitalizationIndicatorLabel} semanticLabel={hospitalizationIndicatorShortLabel} field={'hospitalizationIndicator'} legendStyles={{ marginBottom: '.5rem' }} theme={themes.rebrand} validateOnBlur={true} data-private={true} validateOnChange={true} isRequired={experience === Experience.EMPLOYEE} required={experience === Experience.EMPLOYEE} optional={experience === Experience.EMPLOYER} initialValue={absenceData && absenceData.hospitalizationIndicator}>
            <Radio containerStyle={{ marginBottom: '.5rem' }} data-testid={'hi-yes'} key={'hi-yes'} data-private={true} name='hospitalizationIndicator' label={t(AboutYourAbsenceText.formLabels.yes)} value={'Y'}/>
            <Radio containerStyle={{ marginBottom: '.5rem' }} data-testid={'hi-no'} key={'hi-no'} data-private={true} name='hospitalizationIndicator' label={'No'} value={'N'}/>
          </RadioGroup>
        </Col>
      </Row>
    </>);
};
export default HospitalizationIndicator;
